export default "__VITE_ASSET__c5dda2dc__"